import styled from 'styled-components';

export const DocumentWrapper = styled.div`
  .document-container {
    width: 327px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 12px;
    margin-right: 16px;
  }

  .document {
    display: flex;
    flex-direction: column;
  }

  .document-name {
    font-size: 13px;
    font-family: Roboto;
    color: #2b2727;
  }

  .document-type {
    font-size: 13px;
    font-family: Roboto;
    color: #999999;
    text-transform: uppercase;
  }
`;

export const Icon = styled.span`
  cursor: pointer;
`;
